// pseudo-control.directive.ts
import {
  Directive,
  ElementRef,
  HostBinding,
  HostListener,
  Input,
  OnDestroy,
} from "@angular/core";
import { AbstractControlDirective, NgControl } from "@angular/forms";
import { MatFormFieldControl } from "@angular/material/form-field";
import { Subject } from "rxjs";

@Directive({
  standalone: true,
  selector: "[matPseudoControl]",
  providers: [
    { provide: MatFormFieldControl, useExisting: MatPseudoControlDirective },
  ],
})
export class MatPseudoControlDirective
  implements MatFormFieldControl<unknown>, OnDestroy
{
  static nextId = 0;

  readonly stateChanges = new Subject<void>();
  readonly controlType = "mat-pseudo-control";

  @HostBinding() id = `mat-pseudo-${MatPseudoControlDirective.nextId++}`;
  @HostBinding("attr.aria-describedby") describedBy = "";

  @Input() required = false;
  @Input() disabled = false;
  @Input() errorState = false;

  focused = false;

  private _empty = false;
  @Input() set empty(v: boolean) {
    this._empty = v;
    this.stateChanges.next();
  }
  get empty() {
    return this._empty;
  }

  get shouldLabelFloat() {
    return this.focused || !this.empty;
  }

  constructor(private _el: ElementRef<HTMLElement>) {}
  value: unknown;
  placeholder: string;
  ngControl: NgControl | AbstractControlDirective;
  autofilled?: boolean;
  userAriaDescribedBy?: string;
  disableAutomaticLabeling?: boolean;

  setDescribedByIds(ids: string[]) {
    this.describedBy = ids.join(" ");
  }

  onContainerClick() {
    // Essaie de donner le focus à un enfant focusable si présent
    const root = this._el.nativeElement;
    const focusable = root.querySelector<HTMLElement>(
      "input,button,textarea,select,[tabindex]",
    );
    focusable?.focus();
  }

  @HostListener("focusin") _focusIn() {
    this.focused = true;
    this.stateChanges.next();
  }
  @HostListener("focusout") _focusOut() {
    this.focused = false;
    this.stateChanges.next();
  }

  ngOnDestroy() {
    this.stateChanges.complete();
  }
}
